import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-group",
  "use": "icon-group-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-group\"><path d=\"M16.25 17.5H3.75a1.25 1.25 0 0 1-1.25-1.25V6.875a1.251 1.251 0 0 1 1.25-1.25h3.542c.27 0 .533.088.75.25L10.208 7.5h6.042a1.251 1.251 0 0 1 1.25 1.25v7.5a1.25 1.25 0 0 1-1.25 1.25ZM7.291 6.875H3.75l.001 9.375h12.5v-7.5H9.791l-2.5-1.875ZM17.5 5.625h-6.459l-2.5-1.875H3.75V2.5h4.792c.27 0 .533.088.75.25l2.166 1.625H17.5v1.25Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol